module.exports = __webpack_public_path__ + "static/media/BPC.daba320d.jpg";